/// <amd-module name="VSSUI/Components/PivotBar/PivotBarItem" />
import * as React from "react";
import { BaseComponent } from "OfficeFabric/Utilities";
import { css } from "VSSUI/Util";
import { getNativeProps, divProperties } from "OfficeFabric/Utilities";
import { IPivotBarItemProps } from "../../Components/PivotBar/PivotBarItem.Props";

/** @deprecated */
export class PivotBarItem extends BaseComponent<IPivotBarItemProps> {
    public render() {
        return (
            <div {...getNativeProps<any>(this.props, divProperties)} className={css("vss-PivotBarItem", this.props.className)}>
                {this.props.children}
            </div>
        );
    }
}
